<script setup lang="ts">
defineProps({
  title: {
    type: String as PropType<string>,
    default: "",
  },
  text: {
    type: String as PropType<string>,
    default: "",
  },
})
</script>

<template>
  <section
    v-if="text"
    class="flex h-full flex-col self-start font-national2condensed lg:self-center"
  >
    <h4
      class="font-national2condensed text-4xl font-extrabold text-[--theme-dark] lg:text-5xl 2xl:text-6xl 2xl:leading-[4rem]"
    >
      {{ title }}
    </h4>
    <p
      class="line-clamp-12 text-pretty pt-2 font-numeraWebRegular text-xl font-light leading-normal tracking-wider text-[--theme-darkest] lg:text-2xl 2xl:line-clamp-8 2xl:text-3xl 2xl:leading-relaxed"
    >
      {{ text }}
    </p>
  </section>
</template>

<style scoped lang="postcss"></style>
